import { TTagColor } from '@/shared/Tags/Tag'
import { IEquipment } from '../../../equipment.types.ts'

const getStateColor = (state: IEquipment['state']): TTagColor => {
  switch (state) {
    case 'PENDING':
      return 'purple'
    case 'ERROR':
      return 'red'
    case 'STOPPED':
    case 'DISCONNECTED':
      return 'gray'
    case 'RUNNING':
      return 'green'
  }
}

const getLiftStatusFlagText = (status: IEquipment['statusFlag']) => {
  switch (status) {
    case 'NORMAL':
      return 'ОК'
    case 'ERROR':
      return 'Ошибка'
    case 'FATAL_FAULT':
      return 'Неустранимая ошибка'
    case 'WARNING':
      return 'Предупреждение'
    case 'IN_MAINTENANCE':
      return 'Обслуживание'
  }
}

const getLiftStatusFlagColor = (status: IEquipment['statusFlag']): TTagColor => {
  switch (status) {
    case 'NORMAL':
      return 'green'
    case 'WARNING':
      return 'orange'
    case 'ERROR':
      return 'red'
    case 'FATAL_FAULT':
      return 'red'
    case 'IN_MAINTENANCE':
      return 'geekblue'
  }
}

const equipmentStatusUtils = { getStateColor, getLiftStatusFlagText, getLiftStatusFlagColor }
export default equipmentStatusUtils
